import { Log } from '@probe.gl/log';
const defaultLogger = new Log({ id: 'deck' });
export default defaultLogger;
